import { defineMessages } from "react-intl";

const PrimeReactMessages = defineMessages({
  of: {
    defaultMessage: "of",
    id: "datatable.paginator.of",
  },
  to: {
    defaultMessage: "to",
    id: "datatable.paginator.to",
  },
});

export default PrimeReactMessages;
